var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting_content" }, [
    _c("div", { staticClass: "setting_content_main" }, [
      _c("form", { on: { change: _vm.logChangeData } }, [
        _c("div", { staticClass: "setting_content_heading" }, [
          _c("h2", { staticClass: "setting_content_title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.labelProperties.HEAD_TITLE) +
                "\n        "
            )
          ])
        ]),
        _c("div", { staticClass: "setting_unit" }, [
          _c("p", { staticClass: "setting_unit_title" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.labelProperties.NUMBER_JOB_DISPLAY) +
                "\n        "
            )
          ]),
          _c("div", { staticClass: "setting_unit_item" }, [
            _c("p", { staticClass: "setting_unit_label" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.labelProperties.MAX_JOB_DISPLAY) +
                  "\n          "
              )
            ]),
            _c("div", { staticClass: "setting_unit_form" }, [
              _c("div", { staticClass: "setting_unit_form_holder" }, [
                _c("div", { staticClass: "setting_form_wrapper" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.displaySetting.displayRecord,
                        expression: "displaySetting.displayRecord"
                      }
                    ],
                    staticClass: "setting_form_text",
                    attrs: { type: "number", min: "1", max: "50", step: "1" },
                    domProps: { value: _vm.displaySetting.displayRecord },
                    on: {
                      keypress: function(event) {
                        return _vm.checkInputNumber(event)
                      },
                      input: [
                        function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.displaySetting,
                            "displayRecord",
                            $event.target.value
                          )
                        },
                        _vm.checkInputDisplayRecord
                      ]
                    }
                  })
                ]),
                _c("span", { staticClass: "setting_unit_form_holder_text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.labelProperties.CASE) +
                      "\n              "
                  )
                ])
              ])
            ])
          ])
        ]),
        _c(
          "div",
          {
            staticClass: "setting_unit",
            on: {
              change: function($event) {
                return _vm.updateJobNewWindow()
              }
            }
          },
          [
            _c("p", { staticClass: "setting_unit_title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.labelProperties.VIEW_JOB_NEW_WINDOW) +
                  "\n        "
              )
            ]),
            _c("div", { staticClass: "setting_unit_item" }, [
              _c("p", { staticClass: "setting_unit_label" }, [
                _vm._v(_vm._s(_vm.labelProperties.JOB_DISPLAY_TYPE))
              ]),
              _c("div", { staticClass: "setting_unit_form" }, [
                _c("label", { staticClass: "setting_form_radio_label" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.displaySetting.jobNewWindow,
                        expression: "displaySetting.jobNewWindow"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      value: "false",
                      id: "is_job_new_window_0",
                      checked: "checked"
                    },
                    domProps: {
                      checked: _vm._q(_vm.displaySetting.jobNewWindow, "false")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.displaySetting,
                          "jobNewWindow",
                          "false"
                        )
                      }
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "setting_form_radio_text",
                      attrs: { for: "is_job_new_window_0" }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.labelProperties.SAME_SCREEN) +
                          "\n              "
                      )
                    ]
                  )
                ]),
                _c("label", { staticClass: "setting_form_radio_label" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.displaySetting.jobNewWindow,
                        expression: "displaySetting.jobNewWindow"
                      }
                    ],
                    attrs: {
                      type: "radio",
                      value: "true",
                      id: "is_job_new_window_1"
                    },
                    domProps: {
                      checked: _vm._q(_vm.displaySetting.jobNewWindow, "true")
                    },
                    on: {
                      change: function($event) {
                        return _vm.$set(
                          _vm.displaySetting,
                          "jobNewWindow",
                          "true"
                        )
                      }
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "setting_form_radio_text",
                      attrs: { for: "is_job_new_window_1" }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.labelProperties.NEW_WINDOW) +
                          "\n              "
                      )
                    ]
                  )
                ])
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }